<script>
  import { fly } from 'svelte/transition';

  export let visible;
  export let title;
  export let body;
</script>

{#if visible}
  <div
    class="feedback-completion feedback-el"
    in:fly={{ x: 600, duration: 600 }}
    out:fly={{ x: -600, duration: 600 }}>
    <img src="images/logos/cesLogoGrey.svg" alt="CES Logo" class="centered" />
    <h1 class="main-heading center-heading">{title}</h1>
    <p class="center-text">{body}</p>
    {#if title === 'Submission Error'}
      <a class="btn" href={`${window.origin}/feedback`}>Try Again</a>
    {/if}
    <a class="btn" href={window.location.origin}>Back To The Homepage</a>
  </div>
{/if}
